window.addEventListener('load', function () {
    // find all input selectors
    let qtyInputsAll = document.querySelectorAll('.input-qty')
    let qtyButtonsAll = document.querySelectorAll('.btn-number')

    function qtyInputChangeCallback (event) {
        let activeInputElement = event.target.id
        let activeQtyValue = event.target.value
        qtyInputsAll.forEach((input) => {
            if (input.id !== activeInputElement) {
                input.value = activeQtyValue
            }
        })
    }

    function qtyButtonChangeCallback (event) {
        let ourParentChildren = event.target.offsetParent.childNodes
        ourParentChildren.forEach((child) => {
            if (child.localName === 'input' && child.name !== 'id') {
                const ourQtyId = child.id
                let ourQtyValue = parseInt(child.value)
                if (event.target.classList.contains('quantity-plus')) {
                    ourQtyValue = ourQtyValue + 1
                }
                if (event.target.classList.contains('quantity-minus')) {
                    ourQtyValue = ourQtyValue - 1
                }
                qtyInputsAll.forEach((input) => {
                    if (input.id !== ourQtyId && ourQtyValue !== 0) {
                        input.value = ourQtyValue
                    }
                    if (input.id !== ourQtyId && ourQtyValue === 0) {
                        input.value = 1
                    }
                })
            }
        })
    }

    //add unique ID attributes
    qtyInputsAll.forEach((input, key) => input.setAttribute('id', 'rae-qty-input' + key))
    qtyButtonsAll.forEach((input, key) => input.setAttribute('id', 'rae-qty-button' + key))
    // add input listeners
    qtyInputsAll.forEach((input) => input.addEventListener('input', qtyInputChangeCallback, true))
    //add click listeners to + - buttons
    qtyButtonsAll.forEach((button) => button.addEventListener('click', qtyButtonChangeCallback, true))
})